export default __webpack_public_path__ + "images/70713cc4b10a2d1d1080fcecc7e25f10.png";